import React from "react";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MastersOrganismListContainer } from "./list/list";
import { setOrganisms } from "../../../../../redux/reducers/catalog/catalog";
import { resetMasterOrganismList } from "../../../../../redux/reducers/resources/master/organism/list";

export class MasterOrganismContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterOrganismList());
        store.dispatch(setOrganisms([]));
    }

    render(): React.ReactNode {
        return (
            <MastersOrganismListContainer
                widthPopUp={widths.master.default}
                heigthPopUp={heights.master.default}
            />
        );
    }
}
